import React from "react";
import "assets/styles/profile/style.css";
import MainContent from "components/profile";
import { InfoProvider } from "context/InfoContext";

const Profile = (props) => {
  return (
    <InfoProvider>
      <MainContent />
    </InfoProvider>
  );
};

export default Profile;
